import { CssBaseline, ThemeProvider } from '@mui/material';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { LocationAgent } from './_/BreadcrumbAgent';
import { CenterBox } from './_/CenterBox';
import { Bestiary } from './bestiary/Bestiary';
import { Character } from './character/Character';
import { Contact } from './contact/Contact';
import { StaticSheet } from './create_character/Sheet';
import { Fall } from './fall/Fall';
import { Fight } from './fight/Fight';
import { Focus } from './focus/Focus';
import { Header } from './header/Header';
import './index.css';
import { Mechanics } from './mechanics/Mechanics';
import reportWebVitals from './reportWebVitals';
import { Shop } from './shop/Shop';
import { Skills } from './skills/Skills';
import { Template } from './template/Template';
import theme from './theme';
import BuyMeACoffee from './_/components/BuyMeACoffee';
import { rawSkills } from './content/skills';
import { Splot } from './settings/splot/Splot';
import { Nodea } from './settings/nodea/Nodea';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);


const f = ["Wir", "Szarża", "Pocisk", "Transformacja", "Niewidzialność", "Wielka inicjatywa", "Atak niefizyczny", "Rozproszenie", "Pod ręką"]
export default function SkillsGrid() {
  return (
    <div style={{ width: "100vw", minHeight: "100vh", margin: 0, padding: "2rem" }}>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: "5px" }}>
        {rawSkills.sort((a, b) => a.description.length - b.description.length).filter(s => f.includes(s.name)).map((skill, index) => (
          <div key={index} style={{ border: "1px solid #ccc", padding: "1rem" }}>
            <h3 style={{ margin: "0 0 0.5rem 0" }}>{skill.name}</h3>
            <p style={{ margin: 0 }}>{skill.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

if (false)
  root.render(
    <SkillsGrid />
  )

const entry = process.env.REACT_APP_ENTRY;

root.render(
  <React.StrictMode>
    <BrowserRouter>
      {entry == 'splot' ? (
        <Splot />
      ) : entry === "nodea" ? (
        <Nodea />
      ) : (

        <ThemeProvider theme={theme}>
          <CssBaseline enableColorScheme={true}>
            <Template>
              <LocationAgent />
              <BuyMeACoffee />
              <Header />
              <CenterBox>

                <Routes>
                  <Route path="/focus" element={<Focus />} />
                  <Route path="/rules" element={<Mechanics />} />
                  <Route path="/character" element={<Character />} />
                  <Route path="/fight" element={<Fight />} />
                  <Route path="/backpack" element={<Shop />} />
                  <Route path="/skills" element={<Skills />} />
                  <Route path="/bestiary" element={<Bestiary />} />
                  {/* <Route path="/travel" element={<Travel />} /> */}
                  <Route path="/fall" element={<Fall />} />
                  <Route path="/create-character" element={<StaticSheet />} />
                  <Route path="/contact" element={<Contact />} />

                  <Route path="*" element={<Navigate to="/focus" replace />} />
                  {/* <Route path="*" element={<NoMatch />} /> */}
                </Routes>
              </CenterBox>
            </Template>
          </CssBaseline>
        </ThemeProvider>
      )}
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();


